// helpers.ts -- Pure utility functions for C212 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) [T-F02] */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string [T-F02] */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number with 3 decimals (for unit prices) */
export const fmt3 = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 3 });
};

/** Get status badge for approval status (FC210_80) */
export const getStatusBadge = (record: { fc210_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fc210_80 || '').trim();
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  return null;
};

/** Check if record is locked (approved, cannot edit/delete) */
export const isApproved = (record: { fc210_80?: string } | null): boolean => {
  if (!record) return false;
  return (record.fc210_80 || '').trim() === 'P';
};

/** Calculate purchase total = unit price * qty (BR-C01/C02) */
export const calcPurchaseTotal = (unitPrice: number, qty: number): number => {
  return unitPrice * qty;
};
